export const DEFAULT_TASK_DUE_DATE_PRESET = 'threeBusinessDays';
export const DEFAULT_TASK_DUE_TIME_MINUTES = 60 * 8;